var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    { staticClass: "root" },
    [
      _c(
        "w-row",
        { attrs: { grow: "", center: "" } },
        [
          _c(
            "w-col",
            { attrs: { center: "", xs: "12" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", "no-margin": "" } },
                [
                  _c("w-card", [
                    _c("div", { staticClass: "logo" }, [
                      _c("img", {
                        attrs: {
                          src: "/ico/android-chrome-512x512.png",
                          alt: "logo",
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(" Winfakt Admin "),
                    ]),
                    _c(
                      "div",
                      { staticClass: "button-container" },
                      [
                        _c(
                          "w-button",
                          {
                            staticClass: "button",
                            attrs: { xl: "" },
                            on: {
                              click: function ($event) {
                                return _vm.login()
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c("w-fa", {
                                  attrs: { icon: ["fab", "google"], xl: "" },
                                }),
                                _c("span", [_vm._v("Login With Google")]),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }